import { memo } from 'react';
import GenericIcon from './GenericIcon';

export default memo((params) => (
  <GenericIcon {...params}>
    <path d="M7 4V20L20 12L7 4Z" />
  </GenericIcon>
));
